import { render } from "./dpp-schedule.vue?vue&type=template&id=18dd56cc"
import script from "./dpp-schedule.js?vue&type=script&lang=js"
export * from "./dpp-schedule.js?vue&type=script&lang=js"

import "./dpp-schedule.vue?vue&type=style&index=0&id=18dd56cc&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__